"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFinancialAdjustmentCommentRequestSchema = exports.cancelFinancialAdjustmentRequestSchema = exports.decideFinancialAdjustmentApprovalRequestSchema = exports.submitFinancialAdjustmentRequestSchema = exports.createFinancialAdjustmentRequestSchema = exports.financialAdjustmentTypeSchema = void 0;
/**
 * Request contracts for the Financial Adjustment Platform (Sprint C,
 * Part 1) — `FinancialAdjustmentApplicationService`
 * (`backend/src/modules/financial/application/`). Deliberately small,
 * per the frozen design's own "don't expose every internal step
 * immediately" instruction — create/get/submit/approve/cancel only.
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.financialAdjustmentTypeSchema = zod_1.z.enum(['CREDIT_NOTE', 'DEBIT_NOTE', 'REFUND', 'WRITE_OFF', 'VENDOR_CREDIT_NOTE', 'VENDOR_DEBIT_NOTE']);
const createAdjustmentReferenceSchema = zod_1.z.object({
    referenceType: zod_1.z.string().min(1).max(50),
    referenceId: zod_1.z.string().uuid(),
});
const createAdjustmentLineSchema = zod_1.z.object({
    description: zod_1.z.string().min(1).max(255),
    sourceLineType: zod_1.z.string().max(50).optional(),
    sourceLineId: zod_1.z.string().uuid().optional(),
    batchId: zod_1.z.string().uuid().optional(),
    quantity: zod_1.z.number().positive().optional(),
    unitPrice: zod_1.z.number().int().nonnegative().optional(),
    taxableAmount: zod_1.z.number().int().nonnegative(),
    gstPercent: zod_1.z.number().nonnegative().optional(),
    cgstAmount: zod_1.z.number().int().nonnegative().optional(),
    sgstAmount: zod_1.z.number().int().nonnegative().optional(),
    igstAmount: zod_1.z.number().int().nonnegative().optional(),
    cessAmount: zod_1.z.number().int().nonnegative().optional(),
    lineAmount: zod_1.z.number().int(),
});
exports.createFinancialAdjustmentRequestSchema = zod_1.z.object({
    branchId: zod_1.z.string().uuid(),
    type: exports.financialAdjustmentTypeSchema,
    sourceModule: zod_1.z.string().min(1).max(50),
    sourceEntityType: zod_1.z.string().max(50).optional(),
    sourceEntityId: zod_1.z.string().uuid().optional(),
    reasonCode: zod_1.z.string().min(1).max(100),
    reasonText: zod_1.z.string().optional(),
    totalAmount: zod_1.z.number().int().positive(),
    idempotencyKey: zod_1.z.string().min(1).max(200),
    patientId: zod_1.z.string().uuid().optional(),
    paymentModeId: zod_1.z.string().uuid().optional(),
    references: zod_1.z.array(createAdjustmentReferenceSchema).optional(),
    lines: zod_1.z.array(createAdjustmentLineSchema).optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.submitFinancialAdjustmentRequestSchema = zod_1.z.object({
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.decideFinancialAdjustmentApprovalRequestSchema = zod_1.z.object({
    decision: zod_1.z.enum(['APPROVED', 'REJECTED']),
    comments: zod_1.z.string().max(1000).optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.cancelFinancialAdjustmentRequestSchema = zod_1.z.object({
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.addFinancialAdjustmentCommentRequestSchema = zod_1.z.object({
    comment: zod_1.z.string().min(1).max(2000),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
//# sourceMappingURL=financial-adjustment.request.js.map